import { render, staticRenderFns } from "./Forgotten.vue?vue&type=template&id=441e3f3c&scoped=true"
import script from "./Forgotten.vue?vue&type=script&lang=js"
export * from "./Forgotten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441e3f3c",
  null
  
)

export default component.exports